import React from 'react';
import { IconButton, Divider, Paper } from '@material-ui/core';
import { FiArrowUp } from "react-icons/fi";
import PropTypes from 'prop-types';

let value = '';

function LSMedInputWithButton(props) {

    const inputEl = React.useRef(null);
    function onKeyUp(e) {
        if (e.keyCode === 13) {
            props.onSubmit.call(this, inputEl.current);
        }
    }
    function onSubmit(e) {
        props.onSubmit.call(this, inputEl.current);
    }

    return (
        <Paper
            style={{ display: 'flex', flex: 1, alignItems: 'center', boxShadow: 'none', backgroundColor: '#f2f2f2', borderRadius: '0', padding: '5px' }
            } >
            <input
                type="text"
                ref={inputEl}
                placeholder="Input text here"
                {...props}
                onKeyUp={onKeyUp}
                style={{ width: '95%', marginLeft: '8px' }}
            />
            <IconButton
                className="input-with-button--button"
                onClick={onSubmit}
                style={{ fontSize: '18px', alignItems: 'center' }}
            >
                <FiArrowUp />
            </IconButton>
        </Paper >
    );
}

LSMedInputWithButton.propTypes = {
    onSubmit: PropTypes.func,
};

LSMedInputWithButton.defaultProps = {
    onSubmit: () => { },
};

export default LSMedInputWithButton;


// WEBPACK FOOTER //
// ./src/components/LSMedInputWithButton/index.js